// extracted by mini-css-extract-plugin
export default {"feedPanel":"Feeds_feedPanel__o-IpX","story_wrapper":"Feeds_story_wrapper__pd4uR","noStories":"Feeds_noStories__1fdyw","buttons":"Feeds_buttons__ahDly"};